import type { HttpClient } from '../client';
import type { Id } from '@hq/utils';

export interface FavoriteRow {
  id: Id;
  materialId: Id;
  materialCode: string | null;
  materialName: string | null;
  spec: string | null;
  /** 基本单位主键（申领建单必填）。 */
  unitId: Id;
  unitName: string | null;
  referencePrice: number;
  /** 常用数量（下单预填）。 */
  qtyHint: number;
  useCount: number;
  lastUseAt: string | null;
  sortNo: number;
}

export interface FavoriteSaveRequest {
  materialId: Id;
  qtyHint?: number;
  sortNo?: number;
}

/** 常购清单（`wl_favorite`）：移动端"一键复购"，按用户+机构+物资归并。 */
export function createFavoriteApi(http: HttpClient) {
  return {
    list(): Promise<FavoriteRow[]> {
      return http.request<FavoriteRow[]>({ path: '/wl/favorite' });
    },

    /** 加入常购（幂等，已存在则累加使用次数）。 */
    save(body: FavoriteSaveRequest): Promise<FavoriteRow> {
      return http.request<FavoriteRow>({ path: '/wl/favorite', method: 'POST', body });
    },

    /** 下单后回写使用次数（常购一键申领后调用）。 */
    markUsed(materialId: Id, qty?: number): Promise<{ materialId: Id; updated: number }> {
      return http.request<{ materialId: Id; updated: number }>({
        path: `/wl/favorite/${materialId}/use`,
        method: 'POST',
        body: { qty }
      });
    },

    remove(materialId: Id): Promise<{ materialId: Id; removed: number }> {
      return http.request<{ materialId: Id; removed: number }>({
        path: `/wl/favorite/${materialId}`,
        method: 'DELETE'
      });
    }
  };
}

export type FavoriteApi = ReturnType<typeof createFavoriteApi>;
